/**
 * Maps the pre-rename `procedures` question type back onto `repeating_group`.
 *
 * While the `vhs-daily-return-staff` flag is off, core-api serves Procedures under the type it
 * shipped as, so mobile builds from before the rename keep rendering it. The same response feeds
 * this app, which only knows the new value — so fold the old one back in as it arrives rather than
 * teaching every dispatch site about it.
 *
 * Deleted with the rest of the back-compat code: ENG-12126.
 */
const LEGACY_PROCEDURES_QUESTION_TYPE = 'procedures';
const REPEATING_GROUP_QUESTION_TYPE = 'repeating_group';

export const normaliseLegacyQuestionTypes = (payload: unknown): unknown => {
  if (Array.isArray(payload)) {
    payload.forEach(normaliseLegacyQuestionTypes);
    return payload;
  }

  if (payload === null || typeof payload !== 'object') {
    return payload;
  }

  const record = payload as Record<string, unknown>;

  if (record.questionType === LEGACY_PROCEDURES_QUESTION_TYPE) {
    record.questionType = REPEATING_GROUP_QUESTION_TYPE;
  }

  Object.values(record).forEach(normaliseLegacyQuestionTypes);

  return payload;
};
